module.exports = __webpack_public_path__ + "img/baoMing.8f08d564.png";